import {
  Directive,
  ElementRef,
  EventEmitter,
  Output,
  AfterViewInit,
} from '@angular/core';

declare const google: any;

@Directive({
  selector: '[appGoogleAutocomplete]',
})
export class GoogleAutocompleteDirective implements AfterViewInit {
  @Output() placeChanged: EventEmitter<any> = new EventEmitter<any>();

  constructor(private readonly el: ElementRef) {}

  ngAfterViewInit(): void {
    this.initializeAutocomplete();
  }

  initializeAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(
      this.el.nativeElement,
      {
        componentRestrictions: { country: 'TR' },
        types: ['geocode', 'establishment'],
        fields: ['address_components', 'geometry', 'formatted_address']
      }
    );

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      this.placeChanged.emit(place);
    });
  }
}
